module.exports = __webpack_public_path__ + "images/header-logo-spirit.d947df93bc055849898e.gif";